module.exports = __webpack_public_path__ + "img/logo_icone_esquerda.60236e25.svg";